// ESM-Huelle fuer lib/scripts/components/CMP_CMultiClickTime.js (ESM-Welle 5b).
// Originalquelltext unveraendert uebernommen; nur Import/Export sind neu.
// Prototype-Stil bleibt - class-Migration ist ein separater Schritt.
import { CComponent } from './component.js';

function CMultiClickTime(id)
{
    this.construct(id);

    this.name = "CClickNumber";
    this.htmlType = "span";

    this.properties =
    {
        text:
        {
            caption:
            {
                styles:
                {
                    fontSize: "4.5vh",
                    fontFamily: "Verdana, Sans-Serif"
                }
            },
            styles:
            {
                position: "absolute",
                width: "2.5vw",
                height: "7.5vw",
                backgroundColor: ""
            }
        },
        styles:
        {
            left: "1vw",
            top: "1vw"
        }
    }

    this.hour = null;
    this.minute = null;
}

CMultiClickTime.prototype = new CComponent;

CMultiClickTime.prototype.prepare = function()
{
    this.currentLeft = Number(String(this.properties.styles.left).replace("vw",""));

    this.hour = this.addTimeComponent ("hour");

    var text = this.addChild(CTextLabel);
    text.properties.caption.value = ":";
    text.properties = combine(text.properties, this.properties.text);
    text.properties.styles.left = this.currentLeft + "vw";
    text.properties.styles.top = this.properties.styles.top;

    this.currentLeft += 2.5;

    this.minute = this.addTimeComponent ("minute");
    
    this.prepared = true;
}

CMultiClickTime.prototype.addTimeComponent = function(type)
{
    var timeComponent = this.addChild (CMultiClickNumber);
    timeComponent.properties = combine(timeComponent.properties, this.properties);
    timeComponent.preCommaDigits = 2;
    timeComponent.postCommaDigits = 0;
    timeComponent.properties.styles.left = this.currentLeft + "vw";
    timeComponent.prepare();
    timeComponent.preCDArray[0].prepare();

    switch (type)
    {
        case "hour":
            timeComponent.preCDArray[0].numberArray = new Array (0, 1, 2);
//            timeComponent.preCDArray[0].setValue(2);
            break;
        case "minute":
            timeComponent.preCDArray[0].numberArray = new Array (0, 1, 2, 3, 4, 5);
            break;
    }

    this.currentLeft += 10;

    return timeComponent;
}

CMultiClickTime.prototype.getValue = function()
{
    var time = this.hour.getValue() + ":" + this.minute.getValue();

    return time;
}

CMultiClickTime.prototype.setValue = function(value)
{
    var valueParts = value.toString().split(":");

    this.hour.setValue(valueParts[0]);
    this.minute.setValue(valueParts[1]);
}
export { CMultiClickTime };
